/* MotherLeaf Rain Audio - Final Version */
console.log('🌧️ Rain Audio Script Loading...');

(function() {
  'use strict';
  
  console.log('🌧️ Rain Audio Script Started');
  
  // Configuration
  const RAIN_CONFIG = {
    audioUrls: [
      'https://drive.google.com/uc?export=download&id=1RO77aA_swl1_flCSKFKJkBKarC5N7ZEh',
      'https://cdn.pixabay.com/download/audio/2022/05/27/audio_1808fbf07a.mp3',
      'https://www.soundjay.com/misc/sounds/rain-01.mp3'
    ],
    volume: 0.5,
    fadeInDuration: 2000,
    fadeOutDuration: 1500
  };
  
  let rainAudio = null;
  let isPlaying = false;
  let currentUrlIndex = 0;
  
  // Create audio element
  function createAudio() {
    console.log('🌧️ Creating audio element...');
    rainAudio = new Audio();
    rainAudio.loop = true;
    rainAudio.volume = 0;
    rainAudio.preload = 'auto';
    
    rainAudio.addEventListener('canplaythrough', function() {
      console.log('🌧️ Audio loaded successfully:', rainAudio.src);
    });
    
    rainAudio.addEventListener('error', function() {
      console.log('🌧️ Audio failed, trying next source...');
      tryNextUrl();
    });
    
    tryNextUrl();
  }
  
  function tryNextUrl() {
    if (currentUrlIndex < RAIN_CONFIG.audioUrls.length) {
      console.log('🌧️ Trying audio source:', RAIN_CONFIG.audioUrls[currentUrlIndex]);
      rainAudio.src = RAIN_CONFIG.audioUrls[currentUrlIndex];
      currentUrlIndex++;
    } else {
      console.log('🌧️ All audio sources failed');
    }
  }
  
  // Create button
  function createButton() {
    console.log('🌧️ Creating rain button...');
    
    const button = document.createElement('button');
    button.id = 'rain-btn';
    button.innerHTML = '🌧️';
    button.title = 'Toggle rain sounds';
    
    // Button styles
    button.style.cssText = `
      position: fixed !important;
      bottom: 20px !important;
      right: 20px !important;
      width: 60px !important;
      height: 60px !important;
      border-radius: 50% !important;
      border: none !important;
      background: rgba(255, 255, 255, 0.95) !important;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2) !important;
      cursor: pointer !important;
      z-index: 999999 !important;
      font-size: 24px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      transition: all 0.3s ease !important;
    `;
    
    // Button click handler
    button.addEventListener('click', function() {
      console.log('🌧️ Button clicked, isPlaying:', isPlaying);
      
      if (isPlaying) {
        // Stop rain
        if (rainAudio) {
          rainAudio.pause();
          rainAudio.currentTime = 0;
        }
        isPlaying = false;
        button.innerHTML = '🌧️';
        button.style.background = 'rgba(255, 255, 255, 0.95)';
        console.log('🌧️ Rain stopped');
      } else {
        // Start rain
        if (rainAudio) {
          rainAudio.volume = RAIN_CONFIG.volume;
          rainAudio.play().then(() => {
            isPlaying = true;
            button.innerHTML = '🔊';
            button.style.background = 'rgba(76, 175, 80, 0.95)';
            console.log('🌧️ Rain started successfully');
          }).catch(e => {
            console.log('🌧️ Rain play failed:', e);
          });
        }
      }
    });
    
    // Hover effects
    button.addEventListener('mouseenter', () => {
      button.style.transform = 'scale(1.1)';
    });
    
    button.addEventListener('mouseleave', () => {
      button.style.transform = 'scale(1)';
    });
    
    document.body.appendChild(button);
    console.log('🌧️ Button added to page');
  }
  
  // Initialize everything
  function init() {
    console.log('🌧️ Initializing rain audio system...');
    
    // Wait for page to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        console.log('🌧️ DOM ready, starting initialization...');
        createAudio();
        createButton();
      });
    } else {
      console.log('🌧️ DOM already ready, starting initialization...');
      createAudio();
      createButton();
    }
  }
  
  // Start initialization
  init();
  
  console.log('🌧️ Rain Audio Script Setup Complete');
  
})();

console.log('🌧️ Rain Audio Script Loaded Successfully');
